import React from 'react';
import { Button } from '../button/button';
import { ButtonVariant } from '../../core/enums';
import './coder-action-button.scss';

export type CoderActionVariant = 'remove' | 'add';

export interface CoderActionButtonProps {
  variant: CoderActionVariant;
  onClick: () => void;
}

export const CoderActionButton: React.FC<CoderActionButtonProps> = ({
  variant,
  onClick
}) => {
  return (
    <Button
      label={variant === 'remove' ? 'Remove' : 'Add'}
      variant={ButtonVariant.SECONDARY}
      className={`cmx-coder-action-button cmx-coder-action-button--${variant}`}
      onClick={onClick}
      dataTestId={`coder-action-button-${variant}`}
    />
  );
};

CoderActionButton.displayName = 'CoderActionButton';
